import React from 'react';
import ProductsList from "../../../component/productsList/ProductsList";
import { gql } from "@apollo/client";
import PropTypes from 'prop-types';
import { PRODUCT_FRAGMENT } from "../../../component/productPreview/ProductPreview";
import { PRODUCT_LIST_ITEM_FRAGMENT } from '../../../query/productFragments';
import useProductSearchVariables from "./hooks/useProductSearchVariables";

const SEE_PRODUCTS = gql`
    query SeeProducts($filter: ProductFilter!, $offset: Int, $limit: Int, $sort: String) {
        searchProducts(filter: $filter, offset: $offset, limit: $limit, sort: $sort) {
            ...ProductFragment
            ...ProductListItemFragment
            price
        }
    }
    ${PRODUCT_FRAGMENT}
    ${PRODUCT_LIST_ITEM_FRAGMENT}
`;

/**
 * 검색 결과 상품 컨테이너 컴포넌트
 * 필터와 키워드를 기반으로 상품 검색 API를 호출하고 결과를 표시합니다.
 * 데이터 로직을 `useProductSearchVariables` 훅으로 분리하여 가독성과 재사용성을 높였습니다.
 */
const SearchProductContainer = ({ className, keyword, filters, sortValue = 'RELEVANCE', schemaOrgPreview }) => {
    const variables = useProductSearchVariables(keyword, filters, sortValue);

    // 필터 없이 키워드만으로 검색한 경우인지 판정한다.
    // (useProductSearchVariables 는 필터가 없으면 filter 에 query 하나만 담는다)
    // 필터 조합 때문에 0건이 나온 경우는 정상적인 사용자 동작이므로 404 로 내리지 않고 noindex 만 적용한다.
    // 키워드 없는 /search(전체 상품)도 404 대상에서 제외한다.
    const isPlainKeywordSearch = Boolean(keyword) && Object.keys(variables.filter).length === 1;

    return (
        <div className={className}>
            <ProductsList
                itemsProperty="searchProducts"
                query={SEE_PRODUCTS}
                variables={variables}
                limit={40}
                schemaOrgPreview={schemaOrgPreview}
                keyword={keyword}
                noindexWhenEmpty
                notFoundWhenEmpty={isPlainKeywordSearch}
            />
        </div>
    );
};

SearchProductContainer.propTypes = {
    className: PropTypes.string,
    keyword: PropTypes.string,
    filters: PropTypes.object,
    sortValue: PropTypes.string,
    schemaOrgPreview: PropTypes.object,
};

export default SearchProductContainer;
